/**
 * Xtream EPG (and many other panel responses) base64-encode UTF-8 strings.
 * Naïvely doing `atob(v)` gives a Latin-1 byte string, which renders accented
 * characters as mojibake (e.g. "é" → "Ã©"). Decode the bytes as UTF-8.
 *
 * Returns the input unchanged if it doesn't look like base64 of printable text.
 */
export function decodeMaybeUtf8(v: string | undefined | null): string {
  if (!v) return "";
  try {
    const bin = atob(v);
    // Bail if the decoded bytes contain ASCII control chars — almost certainly
    // not a base64-encoded human-readable string.
    if (/[\x00-\x08\x0e-\x1f]/.test(bin)) return v;
    if (typeof TextDecoder !== "undefined") {
      const bytes = new Uint8Array(bin.length);
      for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
      return new TextDecoder("utf-8", { fatal: false }).decode(bytes);
    }
    return bin;
  } catch {
    return v;
  }
}
